import React from "react";
import { useSelector } from "react-redux";
import AdminLayout from "./AdminLayout";
import ReviewerLayout from "./ReviewerLayout";
import UserLayout from "./UserLayout";
import EmployerLayout from "./EmployerLayout";
import PublicLayout from "./PublicLayout";

interface LayoutSelectorProps {
  children: React.ReactNode;
  isPublicRoute?: boolean;
}

const LayoutSelector: React.FC<LayoutSelectorProps> = ({ 
  children, 
  isPublicRoute = false 
}): JSX.Element => {
  const user = useSelector((state: any) => state.app.user);
  const { roleName } = user?.user?.roleDetail || {};

  // If it's a public route, use PublicLayout (no auth required)
  if (isPublicRoute) {
    return <PublicLayout>{children}</PublicLayout>;
  } 
  // Role-based layouts
  switch (roleName) {
    case "admin".toUpperCase():
      return <AdminLayout>{children}</AdminLayout>;
    
    case "seevi_admin".toUpperCase():
      return <ReviewerLayout>{children}</ReviewerLayout>;
    
    case "EMPLOYER_JOB_ADMIN".toUpperCase():
      return <EmployerLayout>{children}</EmployerLayout>;
    
    case "EMPLOYER_USER".toUpperCase():
      return <EmployerLayout>{children}</EmployerLayout>;
    
    default:
      // Fallback to UserLayout for unknown roles
      return <UserLayout>{children}</UserLayout>;
  }
};

export default LayoutSelector;
